/**
 * Validates the upload name with same restrictions as done in backend.
 * @param name string to validate.
 */
export function validateUploadName(name: string): {
  valid: boolean;
  illegalCharacters: string;
  normalizedName: string;
} {
  name = name.trim();

  if (name.length === 0) {
    return {
      valid: false,
      illegalCharacters: '',
      normalizedName: name,
    };
  }

  // Unicode Normalization, NFC form.
  name = name.normalize('NFC');

  const illegalChars = name.match(/[?\\/:"<>|]/g);
  if (illegalChars) {
    const uniqueChars = [...new Set(illegalChars)];
    return {
      valid: false,
      illegalCharacters: uniqueChars.join(' '),
      normalizedName: name,
    };
  }

  return {
    valid: true,
    illegalCharacters: '',
    normalizedName: name,
  };
}
